/*
 *
 * CollaboratorsCreate reducer
 *
 */

import { fromJS } from "immutable"

import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_CATEGORIES_WATCHER,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILED,
  GET_CURRENCY_WATCHER,
  GET_CURRENCY_SUCCESS,
  GET_CURRENCY_FAILED,
  CREATE_COLLABORATOR_SUCCESS,
  CREATE_COLLABORATOR_WATCHER,
  GET_GENDERS_WATCHER,
  GET_GENDERS_SUCCESS,
  GET_GENDERS_FAILED,
  GET_EMPLOYEES_WATCHER,
  GET_EMPLOYEES_SUCCESS,
  GET_EMPLOYEES_FAILED,
  GET_LOCATIONS_WATCHER,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILED
} from "./constants"

export const initialState = fromJS({
  divisions: [],
  categories: [],
  currency: [],
  leaders: [],
  genders: [],
  locations: [],
  isLoadingDivisions: false,
  isLoadingGenders: false,
  isLoadingLeaders: false,
  isLoadingLocations: false,
  isCreating: false,
})

function collaboratorsCreateReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DIVISIONS_WATCHER:
      return state.set("isLoadingDivisions", true)
    case GET_DIVISIONS_SUCCESS:
      return state
        .set("isLoadingDivisions", false)
        .set("divisions", action.payload.divisions)
        /*.set("categories", action.payload.categories)
        .set("currency", action.payload.currency)
        .set("leaders", action.payload.leaders) 
        .set("genders", action.payload.genders)
        .set("locations", action.payload.locations)*/
    case GET_DIVISIONS_FAILED:
      return state.set("isLoadingDivisions", false)
    case GET_GENDERS_WATCHER:
      return state.set("isLoadingGenders", true)
    case GET_GENDERS_SUCCESS:
      return state
        .set("isLoadingGenders", false)
        .set("genders", action.payload)
    case GET_GENDERS_FAILED:
      return state.set("isLoadingGenders", false)
    case GET_EMPLOYEES_WATCHER:
      return state.set("isLoadingLeaders", true)
    case GET_EMPLOYEES_SUCCESS:
      return state
        .set("isLoadingLeaders", false)
        .set("leaders", action.payload)
    case GET_EMPLOYEES_FAILED:
      return state.set("isLoadingLeaders", false)
    case GET_CATEGORIES_WATCHER:
      return state.set("isLoadingCategories", true)
    case GET_CATEGORIES_SUCCESS:
      return state
        .set("isLoadingCategories", false)
        .set("categories", action.payload)
    case GET_CATEGORIES_FAILED:
      return state.set("isLoadingCategories", false)
    case GET_LOCATIONS_WATCHER:
      return state.set("isLoadingLocations", true)
    case GET_LOCATIONS_SUCCESS:
      return state
        .set("isLoadingLocations", false)
        .set("locations", action.payload)
    case GET_LOCATIONS_FAILED:
      return state.set("isLoadingLocations", false)
    case GET_CURRENCY_WATCHER:
      return state.set("isLoadingCurrency", true)
    case GET_CURRENCY_SUCCESS:
      return state.set("isLoadingCurrency", false)
    case GET_CURRENCY_FAILED:
      return state.set("isLoadingCurrency", false)
    case CREATE_COLLABORATOR_SUCCESS:
      return state.set("isCreating", false)
    case CREATE_COLLABORATOR_WATCHER:
      return state.set("isCreating", true)
    default:
      return state
  }
}

export default collaboratorsCreateReducer
